import cn from 'classnames';

import styles from './Accordion.module.scss';
import { AccordionHeadingProps } from './types';

export const AccordionHeading = ({
    children,
    className,
    'aria-level': ariaLevel = 3,
    ...props
}: AccordionHeadingProps) => (
    <div className={cn(styles.heading, className)} role="heading" aria-level={ariaLevel} {...props}>
        {children}
    </div>
);
